import React, { useState } from 'react';
import { collection, doc } from 'firebase/firestore';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import * as XLSX from 'xlsx';
import { db, storage } from '../firebaseConfig';
import { callIsg } from './data';
import TextReview from './TextReview';

export default function TemplateEditor({ definition, data, user, creator, busy, run }) {
  const [file, setFile] = useState(null);
  const [progress, setProgress] = useState('');
  const record = (data.templates || []).find(t => t.id === definition.id);
  const canUpload = !record || creator || record.draftByUid === user?.uid;
  const upload = () => run(async () => {
    if (!file || file.size > 15 * 1024 * 1024) throw new Error('En fazla 15 MB PDF veya Excel seçin.');
    const extension = file.name.split('.').pop().toLowerCase();
    const contentType = ({ pdf: 'application/pdf', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', xls: 'application/vnd.ms-excel' })[extension];
    if (!contentType) throw new Error('PDF veya Excel seçin.');
    let text = '';
    if (extension !== 'pdf') {
      const workbook = XLSX.read(await file.arrayBuffer(), { type: 'array', cellDates: true });
      text = workbook.SheetNames.map(name => `[Çalışma sayfası: ${name}]\n${XLSX.utils.sheet_to_csv(workbook.Sheets[name], { FS: '\t' })}`).join('\n\n');
      if (text.length > 100000) throw new Error('Excel metni 100.000 karakteri aşıyor; dosyayı bölümlere ayırın.');
    }
    const fileId = doc(collection(db, 'isg_sablonlar')).id;
    const storagePath = `isg-sablonlari/${definition.id}/${fileId}/${file.name.replace(/[^\p{L}\p{N}._-]/gu, '_')}`;
    const task = uploadBytesResumable(ref(storage, storagePath), file, { contentType });
    try {
      await new Promise((resolve, reject) => task.on('state_changed', s => setProgress(`Yükleniyor: %${Math.round(s.bytesTransferred / s.totalBytes * 100)}`), reject, resolve));
      await callIsg('isgSaveTemplate', { definitionId: definition.id, fileId, file: { storagePath, fileUrl: await getDownloadURL(task.snapshot.ref), fileName: file.name, contentType, fileSize: file.size }, text, baseVersion: record?.textVersion || 0, proposalVersion: record?.proposalVersion || 0 });
      setFile(null);
      return extension === 'pdf' ? 'Şablon yüklendi. Otomatik okunan metin hazır olunca aşağıda görünecek.' : 'Excel içeriği metne aktarıldı; oluşturucu onayı bekliyor.';
    } finally { setProgress(''); }
  });
  return <section className="cimento-card"><h2>{definition.name} — Ortak Şablon</h2><p>Bu tür için bir kez PDF veya Excel yükleyin. Oluşturucu onayladıktan sonra belge yükleyenlerden tekrar metin istenmez.</p>
    {canUpload && <div className="cimento-form"><label>Şablon dosyası<input type="file" accept=".pdf,.xlsx,.xls" disabled={busy} onChange={e => setFile(e.target.files?.[0] || null)} /></label><button disabled={busy || !file} onClick={upload}>Şablonu Yükle</button></div>}
    {progress && <p>{progress}</p>}
    {record && <TextReview key={record.id} target="template" record={record} user={user} creator={creator} busy={busy} run={run} />}
  </section>;
}
